import styled from "styled-components";

export const RelatedSiteLinkBox = styled.div`
    padding: 0 1rem;
    color: ${({theme}) => theme.colors.text};
    text-decoration: underline;
    &:hover {
        color: ${({theme}) => theme.colors.textHover};
    }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: 1.4rem 2.4rem;
        color: ${({theme}) => theme.colors.textLight};
        text-decoration: none;
        border-radius: 5px;
        background-color: ${({theme}) => theme.colors.background};
        background: ${({theme}) => theme.colors.background};
        font-size: 1.4rem;
        line-height: 1.4rem;
        ${({theme}) => theme.font.presets.regular};
        flex-grow: 1;
        text-align: center;
        margin-right: 2rem;
        &:last-of-type {
            margin-right: 0;
        }
    }
`;

export const RelatedSiteLink = styled.a`
    color: ${({theme}) => theme.colors.text};
    &:hover {
        color: ${({theme}) => theme.colors.textHover};
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        color: ${({theme}) => theme.colors.textLight};
    }
`;
